import { StartApplicationWidget } from './components/StartApplicationWidget';
import { ApplicationWorkflowSwitch } from '../../app/components/ApplicationWorkflowSwitch';

import { VINChoose } from './components/fields/VINChoose';
import { Tabs } from './components/layout/Tabs';
import { DriverQuestions } from './components/DriverQuestions';
import { ApplicationForm } from './components/forms/ApplicationForm';
import { DriversAndVehiclesForm } from './components/forms/driversAndVehicles/DriversAndVehiclesForm';
import { CodeRefEnum } from './components/fields/CodeRefEnum';
import {
  VehicleMakeSelect,
  VehicleModelSelect,
  VehicleYearSelect,
} from './components/fields/VehicleSelect';
import { DriverMinAge } from './components/fields/DriverMinAge';
import { QuickQuoteReview } from './components/QuickQouteReview';
import { Group } from './components/layout/Group';
import { Field } from './components/metadata/Field';
import { RiskListForm } from './components/forms/risk/RiskListForm';
import { AddVehicleBtn } from './components/forms/risk/AddVehicleBtn';
import { RemoveVehicleBtn } from './components/forms/risk/RemoveVehicleBtn';
import { AddBeanBtn, AddBeanBtnTertiary } from './components/forms/AddBeanBtn';
import { VehicleTypeBtn } from './components/forms/risk/VehicleTypeBtn';
import { RemoveBeanBtn } from './components/forms/RemoveBeanBtn';
import { Grid } from './components/layout/Grid';
import { Text } from './components/layout/Text';
import { Expression } from './components/metadata/Expression';
import { Divider } from 'antd';
import { Header } from './components/layout/Header';
import Input from 'antd/lib/input';
import { LineForm } from './components/forms/line/LineForm';
import { DriverListForm } from './components/forms/driver/DriverListForm';
import { Questions } from './components/fields/Questions';
import { Match } from './components/metadata/Match';
import { Data } from './components/metadata/Data';
import { YesNo } from './components/fields/YesNo';
import { BuyStep } from './components/issue/BuyStep';
import { Checkbox } from './components/fields/Checkbox';
import { DatePicker } from './components/fields/DatePicker';
import { PhoneNumberInput } from './components/fields/PhoneNumberInput';
import { Card } from './components/layout/Card';
import { PremiumSum } from './components/PremiumSum';
import { ColumnTable } from './components/layout/ColumnTable';
import { VerifiedAddress, Address, BillingAddressCheckbox } from './components/fields/Address';
import { VehicleIdentifier } from './components/forms/risk/VehicleIdentifier';
import { TooltipHint } from './components/metadata/TooltipHint';
import { PaymentDetailsForm } from './components/forms/payment/PaymentDetailsForm';
import { CollapseTable } from './components/layout/CollapseTable';
import { PaymentMethodSelect, SelectedMethod, PaymentType } from './components/forms/payment/PaymentMethodSelect';
import { CreditCardButton } from './components/forms/payment/CreditCardButton';
import { PaymentPlans } from './components/forms/payment/PaymentPlans';
import { VehicleImageUpload } from './components/forms/risk/VehicleImageUpload';
import { GenericButton } from './components/fields/GenericButton';
import { DriverInfractions } from './components/forms/driver/DriverInfractions';
import { YesNoToggle } from './components/fields/YesNoToggle';
import { SummaryDetails } from './components/forms/policy/SummaryDetails';
import { EstimatedQuote } from './components/EstimatedQuote';
import { LandingPage } from './components/layout/page/LandingPage';
import { SummaryBar } from './components/SummaryBar';
import { AiListForm } from './components/forms/additionalInterest/AiListForm';
import { InterestInCheckbox } from './components/forms/additionalInterest/InterestInCheckbox';
import { DriversCheckbox } from './components/forms/driversAndVehicles/DriversCheckbox';
import { VehiclesCheckbox } from './components/forms/driversAndVehicles/VehiclesCheckbox';
import { InterestType } from './components/forms/additionalInterest/InterestType';
import { InfoTable } from './components/layout/InfoTable';
import { MoneyAmount } from './components/metadata/MoneyAmount';
import { InlineNotification } from './components/fields/InlineNotification';
import { PaymentSuccessful } from './components/PaymentSuccessful';
import { CheckToggle } from './components/fields/CheckToggle';
import { YesNoRadio } from './components/fields/YesNoRadio';
import { ContactPage } from '../../app/components/ContactPage';
import { RetrieveQuote } from './components/RetrieveQuote';
import { RetrieveTokenQuote } from './components/RetrieveTokenQuote';
import { RetrieveCard } from './components/layout/RetrieveCard';
import { RetrieveWidget } from './components/RetrieveWidget';
import {ConsumerConsent} from './components/ConsumerConsent';
import { RetrieveQuoteSummary } from './components/RetrieveQuoteSummary'
import { FAQ } from './components/layout/page/FAQ';
import { NotificationPage } from './components/NotificationPage';
import { PropertyListForm } from './components/forms/property/PropertyListForm';
import { ProtectionDevices, AlarmsSecurity, MonitoringDetection } from './components/forms/property/ProtectionDevices';
import { YearPicker } from './components/fields/YearPicker';
import { SelectForm } from './components/metadata/SelectForm';
import {FormConfiguration} from './components/metadata/FormUIConfig';
import { CoverageStartDate } from './components/CoverageStartDate';
import {DriverListSelect} from './components/fields/DriverListSelect';
import { CoveragesForm, DeductionValueCost, DwellingBaseCoverages, AdditionalCoverages } from './components/forms/coverages/CoverageLineForm';
import { CoverageField } from './components/forms/coverages/CoverageField';
import { RecalculateButton } from './components/forms/coverages/RecalculateButton';
import { AdditionalRiskCoverages } from './components/forms/coverages/AdditionalRiskCoverages';
import { CoverageTable } from './components/forms/coverages/CoverageTable';
import { CoverageTableSummary } from './components/forms/coverages/CoverageTableSummary';
import { MultiCustomUserAttrSummary } from './components/forms/coverages/MultiCustomUserAttrSummary';
import { CoverageItems } from './components/forms/coverages/CoverageItems';
import { SelectScheduledItem } from './components/fields/SelectScheduledItem';

export default {
  //Very generic ones

  Tabs,
  Group,
  Grid,
  Card,
  Header,
  Text,
  Divider,
  YesNo,
  Checkbox,
  DatePicker,
  PhoneNumberInput,
  TooltipHint,
  GenericButton,
  AddBeanBtnTertiary,
  YesNoToggle,
  CheckToggle,
  YesNoRadio,
  YearPicker,

  // Insurance specific / Framework specific / data loading

  StartApplicationWidget,
  ApplicationWorkflowSwitch,
  CodeRefEnum,
  LineForm,
  RiskListForm,
  DriverListForm,
  AddBeanBtn,
  RemoveBeanBtn,
  Expression,
  Data,
  Match,
  Field,
  Questions,
  PremiumSum,
  ColumnTable,
  DriverInfractions,
  SummaryDetails,
  EstimatedQuote,
  LandingPage,
  SummaryBar,
  InfoTable,
  MoneyAmount,
  PaymentSuccessful,
  ContactPage,
  RetrieveQuote,
  RetrieveTokenQuote,
  RetrieveCard,
  RetrieveWidget,
  RetrieveQuoteSummary,
  NotificationPage,
  SelectForm,

  PaymentDetailsForm,
  CollapseTable,
  PaymentMethodSelect,
  PaymentType,
  SelectedMethod,
  CreditCardButton,
  PaymentPlans,

  VINChoose,
  DriverQuestions,
  ApplicationForm,
  DriversAndVehiclesForm,
  VehicleMakeSelect,
  VehicleModelSelect,
  DriverMinAge,
  QuickQuoteReview,
  AddVehicleBtn,
  Input,
  VehicleTypeBtn,
  RemoveVehicleBtn,
  BuyStep,
  VerifiedAddress,
  Address,
  VehicleYearSelect,
  VehicleIdentifier,
  VehicleImageUpload,
  AiListForm,
  InterestInCheckbox,
  InterestType,
  InlineNotification,
  ConsumerConsent,
  FAQ,
  BillingAddressCheckbox,
  PropertyListForm,
  ProtectionDevices,
  AlarmsSecurity,
  MonitoringDetection,
  FormConfiguration,
  CoverageStartDate,
  DriverListSelect,
  DriversCheckbox,
  VehiclesCheckbox
,
  CoveragesForm,
  DeductionValueCost,
  DwellingBaseCoverages,
  AdditionalCoverages,
  CoverageField,
  RecalculateButton,
  AdditionalRiskCoverages,
  CoverageTable,
  MultiCustomUserAttrSummary,
  CoverageTableSummary,
  CoverageItems,
  SelectScheduledItem
};
